import React from 'react';
import Style from './pageHeader.module.scss';

// Design System "Technical Precision": tipografía heredada del body.
const PAGE_HEADER_FONT = 'inherit';

/***
*   Título y subtítulo del módulo, arriba del contenido y a la izquierda;
*   las acciones de la vista van a la derecha, en la misma fila.
**********/
export function PageHeader({ title, subtitle, children, style = {} }) {
  if (!title && !subtitle && !children) return null;

  return (
    <div className={Style.header} style={{ ...s.header, ...style }}>
      {(title || subtitle) && (
        <div style={s.copy}>
          {title && <h2 className={Style.title} style={s.title}>{title}</h2>}
          {subtitle && <p className={Style.subtitle} style={s.subtitle}>{subtitle}</p>}
        </div>
      )}

      {children && <div style={s.actions}>{children}</div>}
    </div>
  );
}

export function PageHeaderButton({ children, icon, variant = 'secondary', onClick, type = 'button' }) {
  const isPrimary = variant === 'primary';

  return (
    <button
      type={type}
      onClick={onClick}
      style={isPrimary ? s.primaryButton : s.secondaryButton}
    >
      {icon}
      {children}
    </button>
  );
}

export function PageHeaderFilterButton({ onClick }) {
  return (
    <PageHeaderButton onClick={onClick} icon={<FilterIcon />}>
      Filtrar
    </PageHeaderButton>
  );
}

export function PageHeaderExportButton({ onClick }) {
  return (
    <PageHeaderButton onClick={onClick} icon={<ExportIcon />}>
      Exportar
    </PageHeaderButton>
  );
}

function FilterIcon() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>;
}

function ExportIcon() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>;
}

const s = {
  header: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 16,
    flexWrap: 'wrap',
    fontFamily: PAGE_HEADER_FONT,
  },
  copy: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    fontFamily: PAGE_HEADER_FONT,
  },
  // headline-lg: 22/30, 700, -0.01em
  title: {
    margin: 0,
    fontSize: '22px',
    lineHeight: '30px',
    fontWeight: 700,
    letterSpacing: '-0.01em',
    color: '#1E293B',
    fontFamily: PAGE_HEADER_FONT,
  },
  // body-md sobre on-surface-variant
  subtitle: {
    margin: '2px 0 0',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 400,
    color: '#475569',
    fontFamily: PAGE_HEADER_FONT,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    flexWrap: 'wrap',
    marginLeft: 'auto',
  },
  // Secundario: blanco con borde 1px
  secondaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    height: 32,
    padding: '0 12px',
    borderRadius: 8,
    border: '1px solid #E2E8F0',
    background: '#FFFFFF',
    boxShadow: 'none',
    fontSize: '12px',
    fontWeight: 600,
    color: '#1E293B',
    cursor: 'pointer',
    fontFamily: PAGE_HEADER_FONT,
  },
  // Primario: amarillo con texto pizarra
  primaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    height: 32,
    padding: '0 16px',
    borderRadius: 8,
    background: '#FFB800',
    color: '#1E293B',
    border: '1px solid #FFB800',
    fontSize: '12px',
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: PAGE_HEADER_FONT,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  },
};
